import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-labels',
  templateUrl: './form-labels.component.html',
  styleUrls: ['./form-labels.component.sass']
})
export class FormLabelsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
